import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { ReactComponent as CloseIcon } from '../img/cross-close.svg'
import { ReactComponent as CloseIconWhite } from '../img/cross-close-white.svg'

interface StyledDialogProps {
  open: boolean
  setOpen: (open: boolean) => void
  content: React.FC
  buttonTop?: string | number
  id?: string
  backDropInvisible?: boolean
  closeButtonWhite?: boolean
  contentMaxWidth?: string | number
  contentMaxHeight?: string | number
}

interface StyleProp {
  buttonTop: string | number
  contentMaxWidth: string | number
  contentMaxHeight: string | number
}

const useStyles = makeStyles<Theme, StyleProp>(() =>
  createStyles({
    container: {
      borderRadius: '4px',
    },
    content: {
      padding: 0,
      overflow: 'hidden',
      maxWidth: ({ contentMaxWidth }) => contentMaxWidth,
      maxHeight: ({ contentMaxHeight }) => contentMaxHeight,
    },
    button: {
      background: 'transparent',
      border: 'none',
      width: '36px',
      height: '36px',
      position: 'absolute',
      right: '16px',
      top: ({ buttonTop }) => buttonTop,
      padding: '0',
      cursor: 'pointer',
    },
  }),
)

export const StyledDialog: React.FC<StyledDialogProps> = ({
  open,
  setOpen,
  content: Child,
  buttonTop = '16px',
  id,
  backDropInvisible = false,
  closeButtonWhite = false,
  contentMaxWidth = '100%',
  contentMaxHeight = '100%',
}) => {
  const classes = useStyles({ buttonTop, contentMaxWidth, contentMaxHeight })
  const mediaMobile = useMediaQuery('(max-width:700px)')
  return (
    <Dialog
      id={id}
      className={classes.container}
      open={open}
      scroll="body"
      hideBackdrop={backDropInvisible}
      maxWidth={false}
    >
      <button
        className={classes.button}
        type="button"
        aria-label="Close dialog"
        data-testid="close-dialog-button"
        onClick={() => setOpen(false)}
      >
        {!mediaMobile && <CloseIcon />}
        {mediaMobile && !closeButtonWhite && <CloseIcon />}
        {mediaMobile && closeButtonWhite && <CloseIconWhite />}
      </button>
      <DialogContent className={classes.content}>
        <Child />
      </DialogContent>
    </Dialog>
  )
}

export default StyledDialog
